<template>
  <div class="fz-sidebar__wishlist" >
    <div class="" v-if="!!itemCount">
      <ShoppingList :list="shoppingList" />
      <SfDivider class="m-tb-10" />
      <div class="fz-sidebar__cart-items">
        {{ $t('Total items:') }}
        <span>{{ itemCount }}</span>
      </div>
      <SfButton
        @click="goTo('/my-account/shopping-list')"
        class="sf-button--full-width sf-button--outline"
      >
        {{ $t('Go to Shopping List') }}
      </SfButton>
    </div>
    <div v-else>
      <SfHeading
        :title="$t('Your shopping list is empty.')"
        :description="$t(`Dont't hesitate and browse our catalog to find something for You!`)"
        :level="2"
      />
    </div>
  </div>
</template>
<script>
import {
  SfHeading,
  SfDivider,
  SfButton,
} from '@storefront-ui/vue';
import { user, ShoppingList } from '@/modules/user';

export default {
  mixins: [user],
  components: {
    SfHeading,
    SfDivider,
    SfButton,
    ShoppingList,
  },
  data() {
    return {
    };
  },
  computed: {
    itemCount() {
      return this.shoppingList.length;
    },
  },
  methods: {
    goTo(path) {
      this.$router.replace(path);
    },
  },
};
</script>
<style lang="scss" scoped>
.fz-sidebar__cart-items {
  margin: var(--spacer-sm) 0;
  text-align: center;
  & > span {
    font-weight: var(--font-medium);
  }
}
</style>
